// src/store/thunks/notesThunks.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../remote/apiService';
import {
    fetchNotesStart,
    fetchNotesSuccess,
    fetchNotesFailure,
    saveNotesStart,
    saveNotesSuccess,
    saveNotesFailure,
} from '../slices/notesSlice';

export const fetchNotes = createAsyncThunk(
    'notes/fetchNotes',
    async ({ courseId, lessonId }: { courseId: number; lessonId: number }, { dispatch }) => {
        dispatch(fetchNotesStart());
        try {
            const response = await apiService.getNotes({ courseId, lessonId });
            if (response.code === 200) {
                dispatch(fetchNotesSuccess({ courseId, lessonId, notes: response.data }));
            } else {
                dispatch(fetchNotesFailure(response.message || '获取笔记失败'));
            }
            return response;
        } catch (error) {
            if (error instanceof Error) {
                dispatch(fetchNotesFailure(error.message));
            } else {
                dispatch(fetchNotesFailure('发生未知错误'));
            }
        }
    }
);

export const saveNotes = createAsyncThunk(
    'notes/saveNotes',
    async ({ courseId, lessonId, notes }: { courseId: number; lessonId: number; notes: string }, { dispatch }) => {
        dispatch(saveNotesStart());
        try {
            const response = await apiService.saveNotes({ courseId, lessonId, notes });
            if (response.code === 200) {
                dispatch(saveNotesSuccess({ courseId, lessonId, notes }));
            } else {
                dispatch(saveNotesFailure(response.message || '保存笔记失败'));
            }
            return response;
        } catch (error) {
            if (error instanceof Error) {
                dispatch(saveNotesFailure(error.message));
            } else {
                dispatch(saveNotesFailure('发生未知错误'));
            }
        }
    }
);
